import React, { useEffect, useState } from "react";
import { db } from "./firebase";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import "./css/NewPrivacyPolicy.css"; // Import your CSS

const NewPrivacyPolicy = () => {
  const [privacyContent, setPrivacyContent] = useState("");
  const [editableContent, setEditableContent] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [loading, setLoading] = useState(true);
  const [showAlert, setShowAlert] = useState(false);

  useEffect(() => {
    const fetchPrivacyPolicy = async () => {
      try {
        const docRef = doc(db, "privacyPolicy", "content");
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          setPrivacyContent(docSnap.data().text);
          setEditableContent(docSnap.data().text);
        } else {
          console.log("No privacy policy document found.");
        }
      } catch (error) {
        console.error("Error fetching privacy policy:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPrivacyPolicy();
  }, []);

  const handleSave = async () => {
    if (!editableContent.trim()) return; // Prevent empty save
    try {
      setLoading(true);
      const docRef = doc(db, "privacyPolicy", "content");
      await updateDoc(docRef, { text: editableContent });
      setPrivacyContent(editableContent);
      setIsEditing(false);
      setShowAlert(true);
      setTimeout(() => setShowAlert(false), 3000); // Auto hide alert
    } catch (error) {
      console.error("Error updating privacy policy:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="privacy-policy-wrapper">
      {/* Success Alert */}
      {showAlert && (
        <div className="success-alert">
          <i className="fas fa-check-circle"></i> Privacy policy updated successfully!
        </div>
      )}

      {/* Header */}
      <div className="privacy-header">
        <div className="header-content">
          <div className="header-left">
            <h1 className="privacy-title">
              <i className="fas fa-shield-alt"></i> Privacy Policy
            </h1>
            <p className="last-updated">
              <i className="fas fa-clock"></i> Last updated: {new Date().toLocaleDateString()}
            </p>
          </div>
          <div className="header-actions">
           
            {isEditing && (
              <>
                <button className="btn-save" onClick={handleSave}>
                  <i className="fas fa-save"></i> Save
                </button>
                <button className="btn-cancel" onClick={() => setIsEditing(false)}>
                  <i className="fas fa-times"></i> Cancel
                </button>
              </>
            )}
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="privacy-content">
        {loading ? (
          <div className="loading-container">
            <div className="spinner"></div>
            <h3>Loading privacy policy...</h3>
          </div>
        ) : isEditing ? (
          <div className="editor-container">
            <div className="editor-toolbar">
              <div className="toolbar-info">
                <i className="fas fa-info-circle"></i> Editing mode enabled
              </div>
              <div className="character-count">
                {editableContent.length} characters
              </div>
            </div>
            <textarea
              className="privacy-editor"
              value={editableContent}
              onChange={(e) => setEditableContent(e.target.value)}
            />
          </div>
        ) : (
          <div className="privacy-display">
            <div
              className="privacy-text"
              dangerouslySetInnerHTML={{ __html: privacyContent }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default NewPrivacyPolicy;
